import {
  AcquisitionSource,
  type SelectableAcquisitionSource,
} from '@this+that/models';

export const ACQUISITION_SOURCE_ORDER: readonly SelectableAcquisitionSource[] =
  [
    AcquisitionSource.SEARCH,
    AcquisitionSource.CHATBOT,
    AcquisitionSource.FRIEND,
    AcquisitionSource.TEAM_INVITE,
    AcquisitionSource.SOCIAL_MEDIA,
    AcquisitionSource.WEBSITE,
    AcquisitionSource.AD,
  ];

export const ACQUISITION_SOURCE_LABEL_KEYS: Record<
  SelectableAcquisitionSource,
  string
> = {
  [AcquisitionSource.SEARCH]:
    'onboarding.acquisitionSource.options.search.label',
  [AcquisitionSource.CHATBOT]:
    'onboarding.acquisitionSource.options.chatbot.label',
  [AcquisitionSource.FRIEND]:
    'onboarding.acquisitionSource.options.recommendation.label',
  [AcquisitionSource.TEAM_INVITE]:
    'onboarding.acquisitionSource.options.teamInvite.label',
  [AcquisitionSource.SOCIAL_MEDIA]:
    'onboarding.acquisitionSource.options.socialMedia.label',
  [AcquisitionSource.WEBSITE]:
    'onboarding.acquisitionSource.options.website.label',
  [AcquisitionSource.AD]: 'onboarding.acquisitionSource.options.ad.label',
};
